
document.addEventListener('DOMContentLoaded', function() {
  var countUpElements = document.querySelectorAll('.d3-2000-air-pdp-spec-highlights .count-up');
  
  if (countUpElements.length === 0) return;

  var observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.2
  };

  var observer = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var element = entry.target;
        startCountUp(element);
        observer.unobserve(element);
      }
    });
  }, observerOptions);

  countUpElements.forEach(function(el) {
    observer.observe(el);
  });

  function startCountUp(el) {
    var target = parseFloat(el.getAttribute('data-target'));
    var isNegative = target < 0;
    var absTarget = Math.abs(target);
    var duration = 2000; // 2 seconds
    var frameDuration = 1000 / 60; // 60fps
    var totalFrames = Math.round(duration / frameDuration);
    var easeOutQuad = function(t) { return t * (2 - t); };
    var frame = 0;

    // Check if it's a decimal number
    var isDecimal = absTarget % 1 !== 0;
    var decimalPlaces = isDecimal ? 1 : 0; // Assuming max 1 decimal place based on design (e.g. 1.6)
    
    // Special handling for specific formats like "1,920" -> data-target should be 1920
    // If the original text had comma, we might want to add it back?
    // But design shows "1,920Wh" -> The unit is separate. The number is 1,920.
    // Let's assume we format with locale string if it's an integer > 1000.

    var counter = setInterval(function() {
      frame++;
      var progress = easeOutQuad(frame / totalFrames);
      var currentCount = absTarget * progress;

      if (frame === totalFrames) {
        currentCount = absTarget;
        clearInterval(counter);
      }

      var formattedNumber = currentCount.toFixed(decimalPlaces);
      
      // If it's an integer and large, add commas? 
      // Design has "1,920".
      if (!isDecimal && absTarget >= 1000) {
          formattedNumber = Math.floor(currentCount).toLocaleString('en-US');
      }

      if (isNegative) {
        el.textContent = '-' + formattedNumber;
      } else {
        el.textContent = formattedNumber;
      }
    }, frameDuration);
  }
});
